import { apiCaller } from './apiCaller';
import storageService from 'lib/storageService';

export const swrConfig = {
  revalidateOnMount: true,
  revalidateOnFocus: false,
  revalidateOnReconnect: true,
  shouldRetryOnError: (error) => {
    // Don't retry on 401 errors (authentication failed)
    if (error?.responseCode === 401) {
      // Clear token - let the ModalSwitch component handle navigation
      storageService.remove('token');
      storageService.remove('refresh');
      return false;
    }
    // Retry other errors
    return true;
  },
  errorRetryInterval: 5000,
  errorRetryCount: 3,
  fetcher: apiCaller,
};
